import * as actionTypes from "./constants";
import { getImage } from "../../screens/Dashboard/utils";

const initialState = {
  apartmentCount: 0,
  alertCount: 0,
  totalConsumption: 0,
  consumptionGraphData: [],
  totalPaidCount: 0,
  totalUnpaidCount: 0,
  totalBillAmount: 0,
  totalCollectedAmount: 0,
  balanceAmount: 0,
  commercialWaterTotal: 0,
  municipalWaterTotal: 0,
  highestConsumption: 0,
  lowestConsumption: 0,
  slabDetails: [],
  loading: false,
  commercialWaterTotalAmount: 0,
  municipalWaterTotalAmount: 0,
  waterSourceData: [],
};

export default function dashboardReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.FETCH_APARTMENTS_INIT_ACTION:
      return {
        ...state,
        apartmentCount: 0,
      };
    case actionTypes.FETCH_APARTMENTS_SUCCESS_ACTION:
      localStorage.setItem(
        "apartmentLength1",
        action.payload?.response_data?.count,
      );
      return {
        ...state,
        apartmentCount: action.payload?.response_data?.count || 0,
      };
    case actionTypes.FETCH_CURRENT_ALERTS_INIT_ACTION:
      return {
        ...state,
        alertCount: 0,
      };
    case actionTypes.FETCH_CURRENT_ALERTS_SUCCESS_ACTION:
      return {
        ...state,
        alertCount: action?.payload?.count || 0,
      };
    case actionTypes.FETCH_SOCOETY_CONSUMPTION_INIT_ACTION:
      localStorage.setItem("totalConsumption", 0);
      return {
        ...state,
        loading: true,
        totalConsumption: 0,
        consumptionGraphData: [],
        highestConsumption: 0,
        lowestConsumption: 0,
      };

    case actionTypes.FETCH_SOCOETY_CONSUMPTION_SUCCESS_ACTION:
      let temConsumptionData = action.payload?.response_data?.data || [];
      let highest = 0;
      let lowest = 0;
      temConsumptionData.map((consumption, i) => {
        if (i === 0) {
          highest = consumption.totalQty;
          lowest = consumption.totalQty;
        }
        if (highest < consumption.totalQty) {
          highest = consumption.totalQty;
        }
        if (lowest > consumption.totalQty) {
          lowest = consumption.totalQty;
        }
      });
      let tempTotalConsumption = action.payload?.response_data?.data.reduce(
        (accum, item) => accum + item.totalQty,
        0,
      );
      localStorage.setItem("totalConsumption", tempTotalConsumption);
      return {
        ...state,
        loading: false,
        totalConsumption: tempTotalConsumption,
        consumptionGraphData: action.payload?.response_data?.data,
        highestConsumption: highest || 0,
        lowestConsumption: lowest || 0,
      };
    case actionTypes.FETCH_SOCOETY_CONSUMPTION_FAIL_ACTION:
      localStorage.setItem("totalConsumption", 0);
      return {
        ...state,
        loading: false,
        totalConsumption: 0,
        consumptionGraphData: [],
        highestConsumption: 0,
        lowestConsumption: 0,
      };
    case actionTypes.FETCH_PENDING_BILL_APARTMENT_INIT_ACTION:
      return {
        ...state,
        totalPaidCount: 0,
        totalUnpaidCount: 0,
      };
    case actionTypes.FETCH_PENDING_BILL_APARTMENT_SUCCESS_ACTION:
      let tempTotalUnpaidCount =
        action?.payload?.response_data?.pendingbills?.length || 0;
      let apartmentLength = JSON.parse(
        localStorage.getItem("apartmentLength1"),
      );
      const totalPaidCount =
        apartmentLength > 0 ? apartmentLength - tempTotalUnpaidCount : 0;
      return {
        ...state,
        totalPaidCount: totalPaidCount || 0,
        totalUnpaidCount: tempTotalUnpaidCount,
      };
    case actionTypes.FETCH_PENDING_BILL_APARTMENT_FAIL_ACTION:
      return {
        ...state,
        totalPaidCount: 0,
        totalUnpaidCount: 0,
      };
    case actionTypes.FETCH_BILL_DETAILS_INIT_ACTION:
      return {
        ...state,
        totalBillAmount: 0,
        totalCollectedAmount: 0,
        balanceAmount: 0,
      };

    case actionTypes.FETCH_BILL_DETAILS_SUCCESS_ACTION:
      let tempTotalCollectedAmount =
        (action?.payload?.response_Data &&
          action?.payload?.response_Data.data[0]?.amountPaid) ||
        0;
      localStorage.setItem("TotalCollectedAmount", tempTotalCollectedAmount);
      return {
        ...state,
        totalBillAmount:
          (action?.payload?.response_Data &&
            action?.payload?.response_Data.data[0]?.amountDue) ||
          0,
        totalCollectedAmount: tempTotalCollectedAmount,
        balanceAmount:
          (action?.payload?.response_Data &&
            action?.payload?.response_Data?.data[0]?.amountDue -
              action?.payload?.response_Data?.data[0]?.amountPaid) ||
          0,
      };
    case actionTypes.FETCH_BILL_DETAILS_FAIL_ACTION:
      localStorage.setItem("TotalCollectedAmount", 0);
      return {
        ...state,
        totalBillAmount: 0,
        totalCollectedAmount: 0,
        balanceAmount: 0,
      };
    case actionTypes.FETCH_COMMERCIAL_WATER_INIT_ACTION:
      return {
        ...state,
        commercialWaterTotal: 0,
        commercialWaterTotalAmount: 0,
      };
    case actionTypes.FETCH_COMMERCIAL_WATER_SUCCESS_ACTION:
      const totalAmount = (action?.payload?.response_data || []).reduce(
        (sum, item) => {
          return sum + (item.amount || 0);
        },
        0,
      );
      return {
        ...state,
        commercialWaterTotal: action?.payload?.total || 0,
        commercialWaterTotalAmount: totalAmount || 0,
      };
    case actionTypes.FETCH_MUNICIPAL_WATER_INIT_ACTION:
      return {
        ...state,
        municipalWaterTotal: 0,
        municipalWaterTotalAmount: 0,
      };
    case actionTypes.FETCH_MUNICIPAL_WATER_SUCCESS_ACTION:
      const municipaltotalAmount = (
        action?.payload?.response_data || []
      ).reduce((sum, item) => {
        return sum + (item.amount || 0);
      }, 0);
      return {
        ...state,
        municipalWaterTotal: action?.payload?.total || 0,
        municipalWaterTotalAmount: municipaltotalAmount || 0,
      };
    case actionTypes.FETCH_GROUND_WATER_INIT_ACTION:
      return {
        ...state,
        groundWaterTotal: 0,
      };
    case actionTypes.FETCH_GROUND_WATER_SUCCESS_ACTION:
      return {
        ...state,
        groundWaterTotal: action?.payload?.total || 0,
      };
    case actionTypes.FETCH_RAIN_WATER_INIT_ACTION:
      return {
        ...state,
        rainWaterTotal: 0,
      };
    case actionTypes.FETCH_RAIN_WATER_SUCCESS_ACTION:
      return {
        ...state,
        rainWaterTotal: action?.payload?.total || 0,
      };
    case actionTypes.FETCH_SLAB_RATE_INIT_ACTION:
      return {
        ...state,
        slabDetails: [],
      };
    case actionTypes.FETCH_SLAB_RATE_SUCCESS_ACTION:
      return {
        ...state,
        slabDetails: action.payload.response_data || [],
      };
    case "SAVE_CURRENT_DATE":
      return {
        ...state,
        currentDate: action.param,
      };
    case "CLEAR_DASHBOARD_REDUCER":
      return {
        ...state,
        ...initialState,
      };
    case actionTypes.ADD_PRIMARY_RWAMEMBER_SUCCESS_ACTION:
      return {
        ...state,
        isClosePrimaryRwa: action?.payload?.status || "",
      };
    case actionTypes.ADD_PRIMARY_RWAMEMBER_FAIL_ACTION:
      return {
        ...state,
        isClosePrimaryRwa: action?.payload?.status || "",
      };
    case actionTypes.FETCH_AGGREGATE_CONSUMPTION_SUCCESS_ACTION:
      return {
        ...state,
        aggregateSocietyConsupmtion:
          action?.payload?.response_data?.societyConsumption || 0,
        maximumSocietyConsupmtion:
          action?.payload?.response_data?.maxConsumption || 0,
      };
    case actionTypes.FETCH_AGGREGATE_CONSUMPTION_INIT_ACTION:
      return {
        ...state,
        aggregateSocietyConsupmtion: 0,
      };
    case actionTypes.FETCH_AGGREGATE_CONSUMPTION_FAIL_ACTION:
      return {
        ...state,
        aggregateSocietyConsupmtion: 0,
        maximumSocietyConsupmtion: 0,
      };
    case actionTypes.FETCH_WATER_SOURCE_DATA_INIT_ACTION:
      return {
        ...state,
        waterSourceData: [],
      };
    case actionTypes.FETCH_WATER_SOURCE_DATA_SUCCESS_ACTION:
      const result = action.payload.WaterSources.map(({ metering_point }) => {
        const sourceEntries = action.payload.entries[metering_point] || [];

        const totalQuantity = sourceEntries.reduce(
          (sum, entry) => sum + (Number(entry?.quantity) || 0),
          0,
        );
        const totalCost = sourceEntries.reduce(
          (sum, entry) => sum + (Number(entry?.cost) || 0),
          0,
        );

        return {
          metering_point,
          totalQuantity: Number(totalQuantity) / 1000,
          totalCost: Number(totalCost),
          ...getImage(metering_point),
        };
      });

      return {
        ...state,
        waterSourceData: result || [],
      };
    case actionTypes.FETCH_WATER_SOURCE_DATA_FAIL_ACTION:
      return {
        ...state,
        waterSourceData: [],
      };
    default:
      return {
        ...state,
      };
  }
}
